import { inject, injectable } from 'inversify';
import {
  AddToCartRequestParams,
  CartServiceInterface,
  CreateCartRequestParams,
  GetCartRequestParams,
  RemoveFromCartRequestParams,
} from './CartService.types';
import HttpClient from '../../../http';
import { Cart } from 'src/types/common';
import { backendUrl } from 'src/config';

@injectable()
class CartService implements CartServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  async createCart({
    accessToken,
    storeSlugName,
    addressId,
  }: CreateCartRequestParams) {
    return this.client.getClient().post<Cart>(
      `/carts/`,
      {
        address_pk: addressId,
        store_slug_name: storeSlugName,
      },
      {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      }
    );
  }

  async getCart({ accessToken, cartId, token }: GetCartRequestParams) {
    const params = token ? { token } : undefined;
    return this.client.getClient().get<Cart>(`/carts/${cartId}`, {
      baseURL: backendUrl,
      headers: {
        Authorization: `Token ${accessToken}`,
      },
      params,
    });
  }

  async addToCart({
    accessToken,
    cartId,
    price,
    productId,
    quantity,
  }: AddToCartRequestParams) {
    return this.client.getClient().post<Cart>(
      `/carts/${cartId}/add/`,
      {
        product: productId,
        quantity,
        price,
      },
      {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      }
    );
  }

  async removeFromCart({
    accessToken,
    cartId,
    productId,
  }: RemoveFromCartRequestParams) {
    return this.client.getClient().delete<Cart>(`/carts/${cartId}/remove/`, {
      baseURL: backendUrl,
      headers: {
        Authorization: `Token ${accessToken}`,
      },
      data: { product: productId },
    });
  }
}

export default CartService;
